export const BUTTON_URL_SOURCE_TYPES = {
  CUSTOM_URL: 'custom-url',
  MARKETPLACE_OFFER: 'marketplace-offer',
  PHONE_NUMBER: 'phone-number',
  MODAL: 'modal',
};

export const ICON_POSITION_OPTIONS = [
  { label: 'Select', value: '' },
  { label: 'Left', value: 'left' },
  { label: 'Top', value: 'top' },
  { label: 'Right', value: 'right' },
  { label: 'Bottom', value: 'bottom' },
];

export const BUTTON_TYPE_OPTIONS = [
  {
    label: 'Primary',
    value: 'primary',
  },
  {
    label: 'Secondary',
    value: 'secondary',
  },
  {
    label: 'Tertiary',
    value: 'tertiary',
  },
  {
    label: 'Custom',
    value: 'custom',
  },
  {
    label: 'Apply Now',
    value: 'apply-now',
  },
];
